<template>
<div id="customContextMenu" class="absolute rounded-xl shadow-xl border-4 border-lifeboost-red z-50 hidden overflow-hidden">
    <svg role="presentation" class="absolute left-4 top-8 w-10" xmlns="http://www.w3.org/2000/svg" width="44.078" height="67.703" viewBox="0 0 44.078 67.703"> <g id="Group_479" data-name="Group 479" transform="translate(1.002 1.376)"> <path id="Path_433" data-name="Path 433" d="M247.424,4535.453s-.477-5.715,6.53-13.748c6.2-7.254,11.607-20.267,8.087-30.256a43.253,43.253,0,0,0-17.864-22.24s-11.417,18.553,12.655,37.2c0,0,5.994-11.227-9.324-25.212" transform="translate(-241.472 -4469.209)" fill="none" stroke="#111827" stroke-width="2"></path> <path id="Path_434" data-name="Path 434" d="M266.24,4482.96s7.422-7.041,12.083,2l10.56,2.377-11.988,1.332a7.055,7.055,0,0,1-4.734,1.441,2.737,2.737,0,0,1-2.3-3.074c-.216-1.559,2.988-3.507,4.2-.606" transform="translate(-246.027 -4471.258)" fill="none" stroke="#111827" stroke-width="2"></path> <path id="Path_435" data-name="Path 435" d="M274.824,4495.392s3.074,11.4-.434,18.243-12.775,7.967-12.775,7.967" transform="translate(-245.177 -4474.025)" fill="none" stroke="#111827" stroke-width="2"></path> </g> </svg>
  <div id="dropdownDots" class="bg-white divide-y divide-gray-100 rounded-lg shadow w-44">
    <ul class="py-2 text-sm text-gray-700 text-right" aria-labelledby="dropdownMenuIconButton">
      <li>
        <a href="https://builder.io/content"
          class="block px-4 py-2 hover:bg-gray-100" target="_blank">Go To Builder.io</a>
      </li>
      <li>
        <a href="https://lifeboostcoffee.myshopify.com/"
          class="block px-4 py-2 hover:bg-gray-100" target="_blank">Main Store</a>
      </li>
      <li>
        <a href="https://lifeboostcoffee.myshopify.com/admin" class="block px-4 py-2 hover:bg-gray-100"
          target="_blank">Shopify Admin</a>
      </li>
    </ul>
    <span class="block py-0.5 skandalna w-9/12"></span>
    <div class="mt-2 py-1">
       <button
       @click="toggleDevMode()"
        class="btn-red block px-4 py-2 text-sm text-white hover:bg-red-600 mx-auto font-ww-regular uppercase font-bold"
        >{{ !devMode ? 'Enable Dev Mode': 'Disable Dev Mode' }}</button>

    </div><span class="bg-gray-200 flex font-semibold justify-center mt-2 text-xs py-px">Lifeboost Sale Stack Menu</span>
  </div>
</div>
</template>
<script setup>
const devMode = useCookie('devMode');

function toggleDevMode() {
  if (devMode.value) {
    devMode.value = false;
  } else {
    devMode.value = true;
  }
}

onMounted(() => {
  window.addEventListener('contextmenu', function (e) {
    if (e.ctrlKey) { // Check if Ctrl key is pressed during right-click
      e.preventDefault(); // Prevent the default right-click action

      // Get your custom context menu element
      var contextMenu = document.getElementById('customContextMenu');

      // Set the position of the menu and show it
      contextMenu.style.top = e.pageY + 'px';
      contextMenu.style.left = e.pageX + 'px';
      contextMenu.style.display = 'block';
    }
  });

  // Optional: Hide the menu when clicking elsewhere
  window.addEventListener('click', function () {
    document.getElementById('customContextMenu').style.display = 'none';
  });
}); 
</script>
